import styled from 'styled-components';

export const FlexRow = styled.div`
    display: flex;
    flex-direction: row;
`;

export const FlexCol = styled.div`
    display: flex;
    flex-direction: column;
`;

export const FlexRowMiddle = styled(FlexRow)`
    align-items: center;
`;

export const FlexColMiddle = styled(FlexCol)`
    justify-content: center;
`;
